<div data-cy="modal-component" class="rounded-2.5xl w-full text-center">
  <!-- Header -->
  <div class="px-12 md:px-24 py-6 md:py-12 border-gray-300 border-b">
    <h1 class="text-xl md:text-3xl" [innerHTML]="title"></h1>
  </div>
  <!-- <hr> -->
  <!-- Body -->
  <div class="px-12 md:px-24 py-6 md:py-12">
    <!-- <h4 class="font-normal">{{ content }}</h4> -->
    <h4 class="font-normal" [innerHTML]="content"></h4>
    <div class="flex justify-center mt-6 md:mt-12">
      @if (closeBtnName) {
        <button
          data-cy="modal-cancel-button"
          (click)="close()"
          class="disabled:opacity-30 mr-3 md:mr-6 disabled:hover:transform-none hover:scale-95 transition-transform btn-main-reverse">
          {{ closeBtnName }}
        </button>
      }
      @if (acceptBtnName) {
        <button
          data-cy="modal-accept-button"
          (click)="accept()"
          class="disabled:opacity-30 disabled:hover:transform-none hover:scale-95 transition-transform btn-main">
          {{ acceptBtnName }}
        </button>
      }
    </div>
    @if (showProvenueErrorInfo) {
      <div class="flex flex-col items-start gap-4 mt-6">
        <p>
          <strong>PV Request ID:</strong>
          {{ provenueErrorService.getPvRequestId() || 'Unknown' }}
        </p>
        <p>
          <strong>PV Proxy Request ID:</strong>
          {{ provenueErrorService.getPvProxyRequestId() || 'Unknown' }}
        </p>
      </div>
    }
  </div>
</div>
